import Entity from '../entity'
import ProductAppointmentOption from './ProductAppointmentOption';

export default class AppointmentOption extends Entity<number>{
    pointOfTime: string;
    tenantId: number = null;
    displayOrder: number = null;
    // productAppointmentOptions: Array<ProductAppointmentOption>;

}